import { Alert, Button, Flex, Form, Input } from "antd";
import { useTranslation } from "react-i18next";

interface Props {
  error: string;
  initialEmail?: string;
  onBackToSignIn: () => void;
  onSubmit: (values: { email: string }) => void;
}

export const ForgotPasswordForm = ({
  initialEmail,
  error,
  onSubmit,
  onBackToSignIn,
}: Props) => {
  const { t } = useTranslation(["common"]);

  return (
    <Form<{ email: string }>
      initialValues={{ email: initialEmail }}
      onFinish={onSubmit}
      layout="vertical"
    >
      <Flex vertical gap="middle">
        {error && <Alert type="error" title={error} showIcon />}

        <Alert
          type="info"
          title={t("passwordLogin.forgotPassword.intro")}
          showIcon
        />

        <Form.Item
          name="email"
          label={t("idpDiscovery.emailLabel")}
          rules={[
            { required: true, message: t("labels.emailRequired") },
            { type: "email", message: t("labels.emailInvalid") },
          ]}
        >
          <Input
            type="email"
            placeholder={t("idpDiscovery.emailPlaceholder")}
            size="large"
            autoComplete="username"
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block size="large">
            {t("passwordLogin.forgotPassword.sendCode")}
          </Button>
        </Form.Item>

        <Button type="link" block onClick={onBackToSignIn}>
          {t("passwordLogin.forgotPassword.backToSignIn")}
        </Button>
      </Flex>
    </Form>
  );
};
